module.exports = (__webpack_require__("dll-reference wxsys"))("./pages/wxsys/lib/base/initenv.js");